"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var functions_1 = require("./functions");
var defaultValue_1 = require("../JSchema/defaultValue");
var validFunction_1 = require("../JSchema/validFunction");
var calcFunction_1 = require("../JSchema/calcFunction");
var aggregateFunction_1 = require("../JSchema/aggregateFunction");
var clearData_1 = require("../JSchema/clearData");
var getValidations_1 = require("../JSchema/getValidations");
var WrappedPropertyBase = /** @class */ (function () {
    function WrappedPropertyBase(dest, parent, propName, schema, options) {
        this.$parent = dest;
        this.$key = propName;
        this.$dirty = undefined;
        this._options = options;
        var internal = (this._internal = {
            vm: null,
            options: options,
            parent: parent,
            schema: schema,
            computed: {},
            watch: {},
            calcargs: [],
            reactiveData: undefined,
            needsCalcArgs: false,
            useComputedModel: false,
            vmUserData: null
        });
        var self = this;
        // root
        if (dest) {
            this.$root = dest.$root;
        }
        else {
            this.$root = this;
        }
        // create schema
        this.$schema = {
            type: schema.type
        };
        if (schema.title !== undefined) {
            this.$schema.title = schema.title;
        }
        if (schema.format !== undefined) {
            this.$schema.format = schema.format;
        }
        // default value
        if (parent[propName] === undefined) {
            options.Vue.set(parent, propName, defaultValue_1.default(schema, true));
            // parent[propName] = defaultValue(schema, true);
            // console.log('current value fixed', propName, parent);
        }
        // wrap schema props;
        /*
        for (let i = 0; i < wrapSchemaProps.length; i++) {
          const field = wrapSchemaProps[i];
          if (schema[field] !== undefined) {
            if (typeof schema[field] !== 'number') {
              wrapSchemaProp(this.$schema, field, internal);
            } else {
              this.$schema[field] = schema[field];
            }
          }
        }
        */
        // wrap schema.emun
        if (schema.enum !== undefined) {
            if (!Array.isArray(schema.enum)) {
                functions_1.wrapSchemaProp(this.$schema, 'enum', internal);
            }
            else {
                this.$schema.enum = schema.enum;
            }
        }
        // wrap schema.required
        if (schema.required !== undefined && schema.type !== 'object' && (typeof schema.required === 'string' || typeof schema.required === 'boolean')) {
            schema.fieldRequired = schema.required;
        }
        functions_1.wrapSchemaProps(this.$schema, internal, 'boolean', ['fieldRequired']);
        /*
        if (schema.fieldRequired !== undefined) {
          if (typeof schema.fieldRequired !== 'boolean') {
            wrapSchemaProp(this, 'fieldRequired', internal, 'boolean');
          } else {
            this.$schema.fieldRequired = schema.fieldRequired;
          }
        }
        */
        // tworzenie funkcji validującej
        if (!options.disableValidations && schema.validFunc) {
            internal.needsCalcArgs = true;
            var validFunc_1 = validFunction_1.default(schema, true, process.env.NODE_ENV === 'development' && schema.debug);
            internal.computed.validFunc = {
                get: function () {
                    // var $value=parent[propName];
                    // const funcvalue = ff(this._data, parent, propName);
                    var funcvalue = validFunc_1.apply(parent, internal.calcargs);
                    if (funcvalue === true || funcvalue === undefined) {
                        return null;
                    }
                    if (funcvalue === false) {
                        return 'validFunc';
                    }
                    return funcvalue;
                }
            };
            internal.watch.validFunc = {
                handler: function (newValue, oldValue) {
                    if (self.$dirty) {
                        self.$validate();
                    }
                },
                immediate: false
            };
        }
        if (!self._options.disableCalculations) {
            // tworzenie funkcji wyliczjącej wartośc na podstawie innych pól
            if (schema.calc) {
                this.$dirty = true;
                internal.needsCalcArgs = true;
                var calcFunc_1 = calcFunction_1.default(schema, true, process.env.NODE_ENV === 'development' && schema.debug);
                internal.computed.calc = {
                    get: function () {
                        if (process.env.NODE_ENV === 'development') {
                            try {
                                var res = calcFunc_1.apply(parent, internal.calcargs);
                                if ((res === undefined && schema.calc.when === undefined && schema.calc.indexOf('undefined') === -1) || res === NaN) {
                                    console.error('[DEBUG] ERR calc result: ', self.$path, schema.calc, res);
                                }
                                return res;
                            }
                            catch (err) {
                                console.error('[DEBUG] ERR calc: ', self.$path, schema.calc, err);
                                return undefined;
                            }
                        }
                        else {
                            try {
                                return calcFunc_1.apply(parent, internal.calcargs);
                            }
                            catch (_a) {
                                return undefined;
                            }
                        }
                        // if (schema.calc ==='this.Dotacja + this.SrodkiWlasne + this.WkladOsobowy + this.WkladRzeczowy + 5')
                    }
                };
                internal.watch.calc = {
                    handler: function (newValue, oldValue) {
                        if (!self.$dirty && (self._options.dirtyOnBlur || self._options.dirtyOnInput)) {
                            self.$dirty = true;
                        }
                        if (newValue !== undefined) {
                            self.$setData(newValue, undefined, true);
                        }
                    },
                    immediate: true
                };
                // computed.calc = calcFunc;
            }
            // tworzenie funkcji sumującej wartość z tablicy
            if (schema.summary) {
                schema.aggregate = {
                    func: 'sum',
                    array: schema.summary.array,
                    property: schema.summary.property,
                    when: schema.summary.when,
                    if: schema.summary.if,
                    delay: schema.summary.delay
                };
                delete schema.summary;
            }
            // tworzenie funkcji sumującej wartość z tablicy
            if (schema.aggregate) {
                internal.needsCalcArgs = true;
                this.$dirty = true;
                var aggregateFunc_1 = aggregateFunction_1.default(schema, true, process.env.NODE_ENV === 'development' && schema.debug);
                // if (schema.aggregate.async) {
                if (schema.aggregate.delay) {
                    // if (false) {
                    setTimeout(function () {
                        // console.log('delayed create aggregate',obj.$path);
                        var asyncVm = new internal.options.Vue({
                            computed: {
                                aggregate: {
                                    get: function () {
                                        // console.log('delayed run aggregate', obj.$path);
                                        if (process.env.NODE_ENV === 'development') {
                                            var res = aggregateFunc_1.apply(parent, internal.calcargs);
                                            if (res === undefined || res === NaN) {
                                                console.error('ERR aggregate:delay result=', res, propName, schema.calc);
                                            }
                                            return res;
                                        }
                                        else {
                                            return aggregateFunc_1.apply(parent, internal.calcargs);
                                        }
                                    }
                                }
                            },
                            watch: {
                                aggregate: function (newValue) {
                                    internal.options.Vue.set(parent, propName, newValue);
                                }
                            }
                        });
                        //  this.vueInstances.push(asyncVm);
                    }, schema.aggregate.delay);
                }
                else {
                    internal.computed.aggregate = {
                        get: function () {
                            if (process.env.NODE_ENV === 'development') {
                                try {
                                    var res = aggregateFunc_1.apply(parent, internal.calcargs);
                                    if (res === undefined || res === NaN) {
                                        console.error('[DEBUG] ERR aggregate result: ', self.$path, schema.aggregate, res);
                                    }
                                    return res;
                                }
                                catch (err) {
                                    console.error('[DEBUG] ERR aggregate: ', self.$path, schema.aggregate, err);
                                    return undefined;
                                }
                            }
                            else {
                                try {
                                    return aggregateFunc_1.apply(parent, internal.calcargs);
                                }
                                catch (_a) {
                                    return undefined;
                                }
                            }
                            // return aggregateFunc()
                        }
                    };
                    internal.watch.aggregate = {
                        handler: function (newValue) {
                            if (!self.$dirty && (self._options.dirtyOnBlur || self._options.dirtyOnInput)) {
                                self.$dirty = true;
                            }
                            // Vue.set(parent, propName, newValue);
                            if (newValue !== undefined) {
                                self.$setData(newValue, undefined, true);
                            }
                        },
                        immediate: true
                    };
                }
            }
        }
        /*
            if (internal.needsCalcArgs) {
              if (options.external) {
                internal.calcargs[4] = options.external;
                // console.log('set external', self.external);
              }
              internal.calcargs[5] = options.schemaMethods;
              internal.calcargs[6] = this;
    
              internal.calcargs[0] = this.$root.$model;
              if (dest && dest.$parent) {
                internal.calcargs[1] = (dest.$parent as IWrappedProperty).$model;
                if ((dest.$parent as IWrappedProperty).$parent) {
                  internal.calcargs[2] = ((dest.$parent as IWrappedProperty).$parent as IWrappedProperty).$model;
                  if (((dest.$parent as IWrappedProperty).$parent as IWrappedProperty).$parent) {
                    internal.calcargs[3] = (((dest.$parent as IWrappedProperty).$parent as IWrappedProperty).$parent as IWrappedProperty).$model;
                  } else {
                    internal.calcargs[3] = {};
                  }
                } else {
                  internal.calcargs[2] = internal.calcargs[3] = {};
                }
              } else {
                internal.calcargs[1] = internal.calcargs[2] = internal.calcargs[3] = {};
              }
            }
            */
    }
    Object.defineProperty(WrappedPropertyBase.prototype, "$model", {
        get: function () {
            return this._internal.parent[this.$key];
        },
        set: function (value) {
            this._internal.parent[this.$key] = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WrappedPropertyBase.prototype, "$value", {
        /*
      public svalueGetFunc(): any {
      return this.internal.parent[this.$key];
      }
      public svalueSetFunc(newValue: any) {
      this.internal.parent[this.$key] = newValue;
      }
      */
        get: function () {
            if (this._internal.useComputedModel) {
                return this._internal.vm.model;
            }
            else {
                return this.getValue();
            }
            // return this.$model;
            // return this.svalueGetFunc();
        },
        set: function (newValue) {
            this.setValue(newValue);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WrappedPropertyBase.prototype, "$form", {
        get: function () {
            return this._internal.options.form;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WrappedPropertyBase.prototype, "$data", {
        get: function () {
            if (this._internal.vmUserData === null) {
                /*
                if (process.env.NODE_ENV === 'development') {
                  console.log('create $data');
                }
                */
                var userData = {};
                this._internal.vmUserData = this._options.Vue.observable({ userData: userData });
            }
            return this._internal.vmUserData.userData;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WrappedPropertyBase.prototype, "$error", {
        /**
         * komunikat błędu
         */
        get: function () {
            return this.$getUserData('error', null);
        },
        set: function (newValue) {
            this.$setUserData('error', newValue);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WrappedPropertyBase.prototype, "$path", {
        get: function () {
            var result = '';
            if (this.$parent) {
                if (this.$parent.$schema.type === 'array') {
                    return this.$parent.$path + '[' + this.$key + ']';
                }
                var ppath = this.$parent.$path;
                if (ppath) {
                    return ppath + '.' + this.$key;
                }
                else {
                    return this.$key.toString();
                }
            }
            return '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WrappedPropertyBase.prototype, "$hasFocus", {
        get: function () {
            return this.$getUserData('focused', false);
            // return this._internal.reactiveData.focused;
        },
        set: function (newValue) {
            if (newValue) {
                this.$setUserData('focused', true);
                // this._internal.reactiveData.focused = true;
                if (this._internal.options.resetOnFocus) {
                    this.$reset();
                }
            }
            else {
                // if (vm.focused) {
                if (true) {
                    /*
             if (typeok) {
                 this.vm.stringValue = null;
             }
             */
                    // this._internal.reactiveData.focused = false;
                    this.$setUserData('focused', false);
                    // console.log('$hasFocus', this.$path, newValue, dirty, self.dirtyOnBlur);
                    if (!this.$dirty && this._options.dirtyOnBlur) {
                        // dirty = true;
                        // console.log('validate on blur', obj.$validate());
                        this.$validate();
                    }
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    WrappedPropertyBase.prototype.$getUserData = function (field, defaultvalue) {
        var value = this.$data[field];
        if (value === undefined) {
            if (defaultvalue === undefined) {
                this._options.Vue.set(this._internal.vmUserData, field, null);
            }
            else {
                this._options.Vue.set(this._internal.vmUserData, field, defaultvalue);
            }
            return this._internal.vmUserData[field];
        }
        return value;
    };
    WrappedPropertyBase.prototype.$setUserData = function (field, value) {
        this._options.Vue.set(this.$data, field, value);
    };
    WrappedPropertyBase.prototype.$destroy = function () {
        if (this._internal.vm) {
            if (this._internal.vm.$destroy) {
                this._internal.vm.$destroy();
            }
        }
    };
    WrappedPropertyBase.prototype.$reset = function () {
        this.$dirty = false;
        // this.internal.vm.error = null;
        this.$error = null;
    };
    WrappedPropertyBase.prototype.$dirtyList = function (result) {
        if (result === undefined) {
            result = [];
        }
        if (this.$dirty) {
            result.push(this);
        }
        return result;
    };
    Object.defineProperty(WrappedPropertyBase.prototype, "$title", {
        get: function () {
            return this.$schema.title ? this.$schema.title : '';
        },
        enumerable: true,
        configurable: true
    });
    WrappedPropertyBase.prototype.$validate = function (value) {
        // let stime = (new Date()).getTime();
        if (value === undefined) {
            value = this.$model;
        }
        var funcs = getValidations_1.getValidations(this._internal.schema, true);
        for (var _i = 0, funcs_1 = funcs; _i < funcs_1.length; _i++) {
            var func = funcs_1[_i];
            var result = func(value, this.$schema);
            if (result) {
                return (this.$error = functions_1.getRuleMessage(this._internal.schema, result, value, this.$schema));
                // return result;
            }
        }
        if (this._internal.schema.validFunc) {
            if (this._internal.vm && this._internal.vm.validFunc) {
                // return this._internal.vm.validFunc;
                return (this.$error = functions_1.getRuleMessage(this._internal.schema, this._internal.vm.validFunc, value, this.$schema));
            }
        }
        /*
        if (this.$schema.validFunc !== undefined) {
          if (this.$schema.validFunc) {
            return (this.$error = getRuleMessage(this._internal.schema, this.$schema.validFunc, value, this.$schema));
          }
          // return (this.internal.vm.error = getRuleMessage(this.internal.schema, this.$schema.validFunc, value, this.$schema));
          // return this.$schema.validFunc;
        }
        */
        return this.$error = null;
    };
    WrappedPropertyBase.prototype.$validateAll = function (result) {
        if (result === undefined) {
            result = [];
        }
        if (this.$validate()) {
            result.push(this);
        }
        return result;
    };
    WrappedPropertyBase.prototype.$setData = function (value, path, fixArraySize) {
        this._options.Vue.set(this._internal.parent, this.$key, value);
        return true;
        // /Vue.set(parent, propName, value);
        // return setData(this._internal.schema, this.$model, value, path, 0, this._internal.options.Vue, fixArraySize);
    };
    WrappedPropertyBase.prototype.$getData = function (checkDataType) {
        return clearData_1.default(this._internal.schema, this.$model, checkDataType);
    };
    // array item
    WrappedPropertyBase.prototype.$removeRow = function (index) {
        if (this.$parent && this.$parent.$schema.type === 'array') {
            return this.$parent.$removeRow(this.$key);
        }
        return false;
    };
    WrappedPropertyBase.prototype.$moveUp = function (index) {
        if (this.$parent && this.$parent.$schema.type === 'array') {
            return this.$parent.$moveUp(this.$key);
        }
        return false;
    };
    WrappedPropertyBase.prototype.$moveDown = function (index) {
        if (this.$parent && this.$parent.$schema.type === 'array') {
            return this.$parent.$moveDown(this.$key);
        }
        return false;
    };
    WrappedPropertyBase.prototype.$clearRow = function (index) {
        if (this.$parent && this.$parent.$schema.type === 'array') {
            return this.$parent.$clearRow(this.$key);
        }
        return false;
    };
    WrappedPropertyBase.prototype.getValue = function () {
        return this.$model;
    };
    WrappedPropertyBase.prototype.setValue = function (newValue) {
        if (!this.$dirty && this._internal.options.dirtyOnInput) {
            this.$dirty = true;
        }
        this.$model = newValue;
    };
    return WrappedPropertyBase;
}());
exports.default = WrappedPropertyBase;
//# sourceMappingURL=WrappedPropertyBase.js.map